export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_CHECK = 'AUTH_CHECK';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_FORGOT = 'AUTH_FORGOT';
export const AUTH_RESET = 'AUTH_RESET';
export const SET_USERDATA = 'SET_USERDATA';
export const AUTH_VERIFY_TOKEN = 'AUTH_VERIFY_TOKEN';
export const GENERAL_SETTING = 'GENERAL_SETTING';
export const POS_ADD_TO_CART = 'POS_ADD_TO_CART';
export const POS_UPDATE_TO_CART_ITEM_QUANTITY = 'POS_UPDATE_TO_CART_ITEM_QUANTITY';
export const POS_ADD_TO_ORDER_DISCOUNT = 'POS_ADD_TO_ORDER_DISCOUNT';
export const POS_UPDATE_TO_ORDER = 'POS_UPDATE_TO_ORDER';
export const POS_REMOVE_FROM_CART = 'POS_REMOVE_FROM_CART';
export const POS_REMOVE_ORDER = 'POS_REMOVE_ORDER';
export const TABLE_ADD_TO_CART = 'TABLE_ADD_TO_CART';
export const TABLE_UPDATE_TO_CART_ITEM_QUANTITY = 'TABLE_UPDATE_TO_CART_ITEM_QUANTITY';
export const TABLE_UPDATE_TO_ORDER = 'TABLE_UPDATE_TO_ORDER';
export const TABLE_REMOVE_FROM_CART = 'TABLE_REMOVE_FROM_CART';
export const TABLE_REMOVE_ORDER = 'TABLE_REMOVE_ORDER';
export const TABLE_SIDE_DRAWER = 'TABLE_SIDE_DRAWER';
export const ADMIN_SIDE_DRAWER = 'ADMIN_SIDE_DRAWER';
export const DEVICE_TOKEN = 'DEVICE_TOKEN';
